export const getBreadcrumb = (pathname) => {
  if (!pathname) return [];
  const paths = pathname.split("/").filter(Boolean);
  const breadcrumbs = [
    {
      name: "Home",
      path: "/",
    },
  ];

  let currentPath = "";
  paths.forEach((item) => {
    currentPath += `/${item}`;
    breadcrumbs.push({
      name: item
        .replace(/-/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      path: currentPath,
    });
  });
  return breadcrumbs;
};